import { createContext, useContext, useState } from 'react';
import SessionStorage from '@/functions/SessionStorage.js';

const CartContext = createContext(undefined);
export const sessionKey = 'session-cart';
const FIRST_ITEM_SHIPPING = 999;
const ADDITIONAL_ITEM_SHIPPING = 499;
export const SITE_TAX_RATE = 0.08;

export function CartProvider({ children }) {
  const [cart, setCart] = useState(SessionStorage.getItem(sessionKey) || []);

  const addToCart = (salesProduct) => {
    setCart((prevCart) => {
      const existingItem = prevCart.find(item => item.id === salesProduct.id);
      if (existingItem) {
        return prevCart.map(item =>
          item.id === salesProduct.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      const newCart = [...prevCart, { ...salesProduct, quantity: 1 }];
      SessionStorage.setItem(sessionKey, newCart);
      return newCart;
    });
  };

  const removeFromCart = (salesProductId) => {
    const newCart = prevCart => prevCart.filter(item => item.id !== salesProductId)
    SessionStorage.setItem(sessionKey, newCart);
    setCart(newCart);
  };

  const updateQuantity = (salesProductId, quantity) => {
    if (quantity <= 0) {
      removeFromCart(salesProductId);
      return;
    }
    const newCart = prevCart => prevCart.map(item => item.id === salesProductId ? { ...item, quantity } : item)
    SessionStorage.setItem(sessionKey, newCart);
    setCart(newCart);
  };

  const clearCart = () => {
    SessionStorage.setItem(sessionKey, []);
    setCart([]);
  };

  const shippingTotal = () => {
    if (cart.length === 0) return 0;
    const shippableItems = cart.filter((item) => !!item.gps_shipping);
    if (shippableItems.length === 0) return 0;

    return shippableItems.reduce((sum, item) => {
      const q = Number(item.quantity) || 0;
      if (q <= 0) return sum;
      return sum + FIRST_ITEM_SHIPPING + (q - 1) * ADDITIONAL_ITEM_SHIPPING;
    }, 0);
  };


  const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);
  const itemTotal = cart.reduce((sum, item) => sum + item.price_usd_cents * item.quantity, 0);
  const taxTotal = itemTotal * SITE_TAX_RATE;
  const totalPrice = () => itemTotal + taxTotal + shippingTotal();

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart,
        totalItems,
        totalPrice,
        shippingTotal,
        taxTotal,
        itemTotal
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
}

// interface SalesProduct {
//   id: string;
//   sales_name: string;
//   sales_description: string;
//   sales_name: string;
//   price_usd_cents: number;
//   sales_square: string;
//   sales_3x2: string
//   description: string;
//   gps_shipping: boolean;
// }
// interface CartItem extends SalesProduct {
//   quantity: number;
// }
// interface CartContextType {
//   cart: CartItem[];
//   addToCart: (product: Product) => void;
//   removeFromCart: (productId: string) => void;
//   updateQuantity: (productId: string, quantity: number) => void;
//   clearCart: () => void;
//   totalItems: number;
//   totalPrice: () => number;
//   taxTotal: number;
//   itemTotal: number
// }